module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/loading-dbf0c5cc.png";